/** Fixed tree row height in px (TO-389 organization-admin-ui REQ-004). */
export const ORG_ROW_HEIGHT = 32
/** Rows rendered above and below the viewport. */
export const ORG_OVERSCAN = 10

export interface WindowInput {
	scrollTop: number
	viewportHeight: number
	rowCount: number
	rowHeight?: number
	overscan?: number
}

export interface RowWindow {
	/** First rendered row (inclusive). */
	start: number
	/** Last rendered row (exclusive). */
	end: number
	/** Spacer heights standing in for the rows outside the window. */
	padTop: number
	padBottom: number
}

/** The slice of rows to render for a scroll position (design §4). */
export function windowFor({
	scrollTop,
	viewportHeight,
	rowCount,
	rowHeight = ORG_ROW_HEIGHT,
	overscan = ORG_OVERSCAN,
}: WindowInput): RowWindow {
	if (rowCount === 0) return { start: 0, end: 0, padTop: 0, padBottom: 0 }
	const first = Math.floor(Math.max(0, scrollTop) / rowHeight)
	const visible = Math.ceil(Math.max(0, viewportHeight) / rowHeight)
	const start = Math.max(0, Math.min(first, rowCount - 1) - overscan)
	const end = Math.min(rowCount, first + visible + overscan)
	return { start, end, padTop: start * rowHeight, padBottom: (rowCount - end) * rowHeight }
}
